import {FilterFactory} from '@dofleini/query-builder';
import {ValidatorProvider} from '@dofleini/validator';
import {Form} from 'antd';
import PropTypes from 'prop-types';
import React, {memo, useCallback, useMemo} from 'react';

import {ReactComponent as IconSvg} from '@/assets/images/warning.svg';
import {Tooltip} from '@/components/Tooltip';
import {useResponsive} from '@/contexts/ResponsiveContext';
import CNAERecordLine from '@/modules/configuration/components/CNAESelect/components/CNAERecordLine';
import {CACHE_KEY_LIST_CNAE_NOMENCLATOR} from '@/modules/configuration/contants/CNAENomenclator';
import CNAENomenclatorApiService from '@/modules/configuration/services/CNAENomenclatorApiService';
import CNAProperties from '@/modules/verification/components/CNAProperties';
import SelectElementCmp from '@/utils/SelectElementCmp';

const CNAESelect = ({value, onChange, filters, ...props}) => {
  const {isMobile} = useResponsive();

  const currentValue = value ? (typeof value === 'object' ? value._id : value) : null;

  const onRenderItem = useCallback(({
    name,
    summary,
    isPartiallyProhibited,
    commercialization
  }, currentValue, isSelected) => {
    return (
      <div className="flex justify-between w-full">
        <CNAERecordLine name={name} summary={summary} isSelected={isSelected}/>
        <div className="flex items-center">
          <CNAProperties value={{isPartiallyProhibited, commercialization}}/>
          {
            (isSelected && !isMobile && !!summary) &&
            <Tooltip
              title={<CNAERecordLine name={name} summary={summary} isSelected={isSelected} forceSummary/>}
              placement="left"
              className="truncate flex items-center justify-center px-2"
            >
              <IconSvg style={{height: 15}} className="flex items-center cursor-pointer"/>
            </Tooltip>
          }
        </div>
      </div>
    );
  }, [isMobile]);

  const filtersWithActive = useMemo(() => FilterFactory.add(filters, {isActive: true}).toQuery(), [filters]);

  return (
    <>
      <div className={'w-full truncate'}>
        <SelectElementCmp
          {...props}
          queryKey={CACHE_KEY_LIST_CNAE_NOMENCLATOR}
          filters={filtersWithActive}
          service={CNAENomenclatorApiService}
          includeValue={value}
          value={currentValue}
          onChange={onChange}
          customItemRender={onRenderItem}
          sort={{code: 1}}
          customMapItem={(v) => ({...v, name: `(${v.code}) ${v.name}`})}
          queryConfig={{refetchOnWindowFocus: false}}
        />
      </div>
    </>
  );
};

CNAESelect.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  filters: PropTypes.object
};

export default memo(CNAESelect);

export const renderCNAESelect = ({formItemProps, field, form}) => {

  const rules = field?.required && [{required: true, message: ValidatorProvider.t('validateMessages.required')}];

  return (
    <Form.Item {...formItemProps} required={field?.required} rules={rules}>
      <CNAESelect {...field?.widgetProps} {...field} form={form}/>
    </Form.Item>
  );
};
